import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AllActionsUnion } from 'src/app/app.actions';
import { AgreementStatuses } from 'src/app/models/agreement-statuses/agreement-statuses';
import { PrivacyPolicyAggregate } from 'src/app/models/privacy-policy/privacy-policy-aggregate';
import { PrivacyPolicyUrl } from 'src/app/models/privacy-policy/privacy-policy-url';
import { PrivacyPolicyVersion } from 'src/app/models/privacy-policy/privacy-policy-version';
import { TermsOfServiceAggregate } from 'src/app/models/terms-of-service/terms-of-service-aggregate';
import { TermsOfServiceUrl } from 'src/app/models/terms-of-service/terms-of-service-url';
import { TermsOfServiceVersion } from 'src/app/models/terms-of-service/terms-of-service-version';
import {
  storeAgreementStatuses,
  storePrivacyPolicy,
  storeTermsOfService,
} from './agreement-statuses.actions';

export interface AgreementStatusesState {
  agreementStatuses: AgreementStatuses;
  privacyPolicy: PrivacyPolicyAggregate;
  termsOfService: TermsOfServiceAggregate;
}

const initialState: AgreementStatusesState = {
  agreementStatuses: new AgreementStatuses(),
  privacyPolicy: new PrivacyPolicyAggregate(),
  termsOfService: new TermsOfServiceAggregate(),
};

export const featureName = 'agreementStatusesFeature';

export function agreementStatusesReducer(
  state_: AgreementStatusesState | undefined,
  action: AllActionsUnion,
): AgreementStatusesState {
  const reducer_ = createReducer<AgreementStatusesState>(
    initialState,
    on(
      storeAgreementStatuses,
      (state, { payload }): AgreementStatusesState => {
        return { ...state, agreementStatuses: payload };
      },
    ),
    on(
      storePrivacyPolicy,
      (state, { payload }): AgreementStatusesState => {
        return { ...state, privacyPolicy: payload };
      },
    ),
    on(
      storeTermsOfService,
      (state, { payload }): AgreementStatusesState => {
        return { ...state, termsOfService: payload };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<AgreementStatusesState>(featureName);

export const getAgreementStatuses = pipe(
  select(
    createSelector(
      getFeature,
      v => v.agreementStatuses,
    ),
  ),
  distinctUntilChanged((a: AgreementStatuses, b: AgreementStatuses) => {
    return a.eq(b);
  }),
);

export const getPrivacyPolicy = pipe(
  select(
    createSelector(
      getFeature,
      v => v.privacyPolicy,
    ),
  ),
  distinctUntilChanged(),
);

export const getTermsOfService = pipe(
  select(
    createSelector(
      getFeature,
      v => v.termsOfService,
    ),
  ),
  distinctUntilChanged(),
);
